import { inject } from '@angular/core';
import { map, type Observable } from 'rxjs';
import { signalStore, withMethods } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { withCursorPagination } from '@dgacontrol-frontend/shared-util-cursor-pagination';

import { LegalService } from './generated/legal/legal.service';
import type {
  LegalAcceptanceCreateRequestV1Request,
  LegalAcceptanceV1,
  LegalV1AcceptancesListParams,
} from './generated/types';

/**
 * Who accepted which versions: the admin acceptances screen reads the list, the web
 * acceptance screen records the client's own acceptance.
 */
export const LegalAcceptancesStore = signalStore(
  withEntities<LegalAcceptanceV1>(),
  withCursorPagination<LegalAcceptanceV1, LegalV1AcceptancesListParams>(() => {
    const api = inject(LegalService);
    return (query, cursor) =>
      api.legalV1AcceptancesList({ ...query, cursor: cursor ?? undefined });
  }),
  withMethods((_store, api = inject(LegalService)) => ({
    /** The caller accepts the versions on screen: 201, or 200 when already accepted
     *  (idempotent — a double click or a retry is harmless). */
    accept(body: LegalAcceptanceCreateRequestV1Request): Observable<LegalAcceptanceV1> {
      return api.legalV1AcceptancesCreate(body).pipe(map((res) => res.legal_acceptance));
    },
  })),
);
